export enum LocalStorageKeys {
  ProductCatalogResponse = "ProductCatalogResponse",
  OriginalProductCatalogResponse = "OriginalProductCatalogResponse",
  SummaryData = "SummaryData",
  TyresData = "tyresData",
  ReturnTransferSummaryData = "returnTransferSummaryData",
  AttachedDocuments = "attachedDocuments",
  ReplacementVehicleSummaryData = "ReplacementVehicleSummaryData",
  PersonalitzationProductData = "PersonalitzationProductData",
  CategoriesMap = "categoriesMap",
  MappedToppings = "mappedToppings",
  ShowUpsertVehicleAlert = "showUpsertVehicleAlert",
  PrefilledVehicleData = "PrefilledVehicleData",
  OrderHashes = "orderHashes",
  OrderHashesFunnel = "orderHashesFunnel",
  OriginalLocationInfo = "originalLocationInfo",
  NoShowAgain = "noShowAgain",
  Language = "language",
  Timezone = "timezone",
  IsInspectionPaid = "IsInspectionPaid",
  ReturnVehicleStorageSummaryData = "returnVehicleStorageSummaryData",
  IsNavbarCollapsed = "IsNavbarCollapsed",
  RoleFilters = "RoleFilters",
  RoleFilterResponseFormated = "RoleFilterResponseFormated",
  UserData = "cafler_ctx_v1",
  Alert = "Alert",
  AccessToken = "AccessToken",
  TokenExpiration = "TokenExpiration",
  TokenTimestamp = "TokenTimestamp",
  IdToken = "IdToken",
  IncidenceReasons = "IncidenceReasons"

}